import templateUrl from './pay-cheque-inquiry-reports.component.html';

export const PayChequeInquiryReportsComponent = {
    controller: PayChequeInquiryReportsController,
    controllerAs: "vm",
    templateUrl
};

function PayChequeInquiryReportsController($q, payrollDashboardService, utilityService, apexApiUrl) {
    'ngInject'
    const vm = this;

    vm.reports;
    vm.startDate;
    vm.endDate;
    vm.filters = {};
    vm.showFilters = true; // Default filters to open.

    vm.onRefreshData = onRefreshData;
    vm.filterReport = filterReport;
    vm.exportXlsx = exportXlsx;

    function onRefreshData() {
        utilityService.showLoading();
        loadPayChequeInquiryReports()
            .catch(function (ex) {
                console.error(ex);
                alert("Refreshing data failed: " + utilityService.getExceptionMessage(ex));
            })
            .then(function () {
                utilityService.hideLoading();
            })
    }

    function loadPayChequeInquiryReports() {
        let getReports;
        if (!vm.startDate || !vm.endDate) {
            getReports = $q.when([]);
        } else {
            getReports = payrollDashboardService.retrievePayChequeInquiryReports(vm.startDate, vm.endDate);
        }
        return getReports.then(function (reports) {
            vm.reports = reports.sort(sortReport);
            vm.totals = reports.reduce(aggregateReportTotals, {});
            return vm.reports;
        });
    }

    function filterReport(report) {
        return !vm.filters.CountryID || report.StateProvince.CountryID === vm.filters.CountryID;
    }

    function sortReport(a, b) {
        if (a.Owner < b.Owner) {
            return -1;
        } else if (a.Owner > b.Owner) {
            return 1;
        }

        if (a.PayChequeDate < b.PayChequeDate) {
            return -1;
        } else if (a.PayChequeDate > b.PayChequeDate) {
            return 1;
        }

        return 0;
    }

    function exportXlsx() {
        window.location.href = kendo.format(apexApiUrl + "payrolls/inquiry.xlsx?startDate={0:yyyy-MM-dd}&endDate={1:yyyy-MM-dd}",
            vm.startDate,
            vm.endDate);
    }

    function aggregateReportTotals(totals, report) {
        totals.NumberOfPayChequesProcessed = (totals.NumberOfPayChequesProcessed || 0)
            + report.NumberOfPayChequesProcessed;
        return totals;
    }
}
